import {
  select,
  fork,
  put,
  all,
  call,
  takeEvery,
} from 'redux-saga/effects'

import {
  updateTablesAction,
  clearTables,
} from 'containers/Entity/actions'

import {
  get,
  patch,
  post
} from 'helpers/RequestUtil'

import {
  FETCH_AE_REGION,
  POST_AE_REGION,
  FETCH_AE_REGION_SELECTION
} from './constants'

import {
  aeRegionSelector
} from './selectors'

import {
  updateAeRegion,
  updateAeRegionSelection,
  fetchAeRegion as fetchAeRegionAction,
  fetchAeRegionStart,
  fetchAeRegionSuccess,
  fetchAeRegionError,
  fetchAeRegionSelectionStart,
  fetchAeRegionSelectionSuccess,
  fetchAeRegionSelectionError,
  postAeRegionStart,
  postAeRegionSuccess,
  postAeRegionError
} from './actions'

function* fetchAeRegion(projectId) {
  try {
    yield put(fetchAeRegionStart())
    const data = yield call(get, `/api/fulcrum/projects/${projectId}/ae_regions`)
    yield put(fetchAeRegionSuccess())
    let project_ae_regions = []
    if (data.entities && data.entities.project_ae_regions) {
      project_ae_regions = Object.values(data.entities.project_ae_regions).map(region => {
        return {
          value: region.aeRegion.id,
          label: region.aeRegion.name
        }
      })
    }
    return project_ae_regions
  } catch(error) {
    yield put(fetchAeRegionError(error))
  }
}

function* postAeRegion(projectId, regions) {
  try {
    yield put(postAeRegionStart())
    const postRequest = post('project_ae_regions', { ae_regions_list: regions })
    yield call(postRequest, `/api/fulcrum/projects/${projectId}/ae_regions`)
    yield put(postAeRegionSuccess())
  } catch(error) {
    yield put(postAeRegionError(error))
  }
}

function* fetchAeRegionSelection(action) {
  try {
    yield put(fetchAeRegionSelectionStart())
    const data = yield call(get, '/api/fulcrum/ae_regions_selection')
    let ae_regions_source = []
    if (data.entities.ae_regions_selections && Object.values(data.entities.ae_regions_selections)[0] && Object.values(data.entities.ae_regions_selections)[0].aeRegions) {
      ae_regions_source = Object.values(Object.values(data.entities.ae_regions_selections)[0].aeRegions).map(region => {
        return {
          value: region.id,
          label: region.name
        }
      })
    }
    yield put(fetchAeRegionSelectionSuccess())
    yield put(updateAeRegionSelection(ae_regions_source))
  } catch(error) {
    yield put(fetchAeRegionSelectionError(error))
  }
}

function* handleFetchAeRegion(action) {
  const { projectId } = action
  const project_ae_regions = yield call(fetchAeRegion, projectId)
  yield put(updateAeRegion(project_ae_regions))
}

function* handlePostAeRegion(action) {
  const { projectId } = action
  const region_labels = yield select(aeRegionSelector)
  let regions = region_labels.map(region => region.value)
  yield call(postAeRegion, projectId, regions)
  yield put(fetchAeRegionAction(projectId))
}

function* watchFetchAeRegion() {
  yield takeEvery(FETCH_AE_REGION, handleFetchAeRegion)
}

function* watchPostAeRegion() {
  yield takeEvery(POST_AE_REGION, handlePostAeRegion)
}

function* watchFetchAeRegionSelection(){
  yield takeEvery(FETCH_AE_REGION_SELECTION, fetchAeRegionSelection)
}

function* loadSagas() {
  yield all([
    fork(watchFetchAeRegion),
    fork(watchPostAeRegion),
    fork(watchFetchAeRegionSelection),
  ])
}

export default loadSagas
